import './ReactImageOverlay.scss'
import ReactImageOverlayProps from './type'

const ReactImageOverlay = ({
  onClick = () => true,
  additionalClass = '',
  children,
  overlay,
  alt = 'Play',
  ariaLabel = '',
  containerWidth = '',
  hoverOverlay
}: ReactImageOverlayProps) => {
  const handleOnSelect = (event: any) => {
    if (event.keyCode !== 9) {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <div
      style={{ width: containerWidth }}
      className={`overlay-container ${additionalClass}`}
      onClick={(event) => handleOnSelect(event)}
      onKeyDown={(event) => handleOnSelect(event)}
    >
      {hoverOverlay && (
        <div className='image-hover-overlay-container'>
          {children}
          <div className='hover-overlay' style={{ background: hoverOverlay?.color }}></div>
        </div>
      )}
      {!hoverOverlay && children}
      <div className='overlay-image'>
        <img src={overlay.src} width={overlay.width} height={overlay.height} alt={alt} aria-label={ariaLabel} tabIndex={0} />
      </div>
    </div>
  )
}
export default ReactImageOverlay
